import { Box, Button } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import { Result, UnhandledResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useGenerateUsingAiForm } from 'modules/performance_process/components/review/show/GenerateUsingAI/useGenerateUsingAiForm'

interface Props {
  onGenerate: (content: string) => Promise<UnhandledResult<Result<unknown>>>
}

export function GenerateUsingAIStandaloneForm({ onGenerate }: Props) {
  const form = useGenerateUsingAiForm({ onGenerate })

  return (
    <Box width="full">
      <form onSubmit={form.handleSubmit}>
        <Box justifyContent="center" alignItems="center" gap="s16" width="full">
          <TextArea
            aria-label={i18n.t('performance_process.reviews.generate_using_ai_modal.field_label')}
            placeholder={i18n.t(
              'performance_process.reviews.generate_using_ai_modal.field_placeholder'
            )}
            error={form.errors.content}
            value={form.values.content}
            onChange={(value) => form.setFieldValue('content', value)}
            maxHeight="s360"
          />
          <Button type="primary" iconName="ai" submit loading={form.isSubmitting}>
            {i18n.t('performance_process.reviews.generate_using_ai_modal.generate')}
          </Button>
        </Box>
      </form>
    </Box>
  )
}
